import { filter } from "lodash";
import React, { useState, useEffect, useRef } from "react";
import {
  Tab,
  Button,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  Container,
  TableRow,
  Paper,
  styled,
  Card,
  Box,
  TextField,
  Accordion,
  Typography,
  AccordionSummary,
  AccordionDetails,
  TablePagination,
  List,
  Grid,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Chip,
  LinearProgress,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import { UserListHead, UserListToolbar } from "../../sections/@dashboard/user";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import {
  GetMatchListByStatus,
  MatchChangeStatusAction,
  ResetMatchChangeStatusAction,
} from "../../redux/actions/MatchAction";
import Loader from "./../../components/Loader";
import moment from "moment";
import "./StatusManagement.css";
import { sr } from "date-fns/locale";
import Iconify from "../../components/Iconify";
import { useNavigate } from "react-router-dom";
import { GetActiveAllContestMatchAction } from "../../redux/actions/MatchAction";
import { GetUserVendorListAction } from "src/redux/actions/UsersAction";
import { DateRangePicker } from "rsuite";
import 'rsuite/dist/rsuite.min.css';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function UpcomingMatches() {
  const dispatch = useDispatch();
  const loadingSelector = useSelector((state) => state.matches.loading);
  const statusSelector = useSelector((state) => state.matches.match_status);
  const poolListData = useSelector(
    (state) => state.matches.active_pool_list.data
  );
  const ContestListData = useSelector(
    (state) => state.matches.upcoming_match_list.data
  );
  const ContestList =
    ContestListData !== undefined && ContestListData.data.match_list;
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [clickStatus, setClickStatus] = useState(false);
  const [loadingAccumulator, setLoadingAccumulator] = useState(false);
  
  let settingsJSON = localStorage?.getItem("security_auth");
  let settings = JSON.parse(settingsJSON);
  const [sVid, setSVid] = useState(settings.id);
  const [state, setState] = useState({
    ContestListData: [],
    totalCountContestList: 0,
    logoImg: [],
    title: "",
    subtitle: "",
    dis_val: "",
  });
  
  let sendPoolData = {
    typeData: "Contest",
    type: "m",
    gtype: "ckt",
    vid: 31,
  };

  let [value, setValue] = useState("UPCOMINGLIVE");
  const [valueTop, setValueTop] = useState("Contest");
  const [dateRng, setDateRng] = useState({
    sdate: new Date(),
    edate: new Date(),
  });

  const handleChange = (_, newValue) => {
    setValue(newValue);
    sendPoolData.vid = sVid;
    sendPoolData.typeData = valueTop;
    if (dateRng.sdate && dateRng.edate) {
      sendPoolData.sdate = dateRng.sdate;
      sendPoolData.edate = dateRng.edate;
    }
    dispatch(
      GetMatchListByStatus(
        newValue,
        sendPoolData.vid,
        sendPoolData.sdate,
        sendPoolData.edate,
        page,
        rowsPerPage
      )
    );
  };

  const UserList = useSelector((state) => state.users.uservendor_list.data);
  const USERLIST = UserList !== undefined && UserList.data.users;

  const handleChangeTop = async (_, newValue) => {
    setValueTop(newValue);
    sendPoolData["typeData"] = newValue;
    sendPoolData.vid = sVid;
    
    if (dateRng.sdate && dateRng.edate) {
      sendPoolData.sdate = dateRng.sdate;
      sendPoolData.edate = dateRng.edate;
    }
    
    // Accumulator के लिए loading state set करें
    if (newValue === "Accumulator") {
      setLoadingAccumulator(true);
    }
    
    // Current tab के according limit set करें
    const limit = newValue === "Accumulator" ? 50 : 1000;
    await dispatch(GetActiveAllContestMatchAction(1, limit, sendPoolData));
    
    if (newValue === "Accumulator") {
      setLoadingAccumulator(false);
    }
  };

  useEffect(() => {
    if (ContestListData !== undefined) {
      setState({
        ...state,
        ContestListData: ContestListData.data.match_list,
        totalCountContestList: ContestListData.data.total_count,
      });
    }
  }, [ContestListData]);

  useEffect(() => {
    dispatch(GetUserVendorListAction(1, null, 1));
  }, [dispatch]);

  useEffect(() => {
    if (UserList !== undefined) {
      setState({ ...state, userList: UserList.data.users });
    }
  }, [UserList]);

  useEffect(() => {
    sendPoolData.vid = sVid;
    sendPoolData.typeData = valueTop;
    
    if (dateRng.sdate && dateRng.edate) {
      sendPoolData.sdate = dateRng.sdate;
      sendPoolData.edate = dateRng.edate;
    }
    
    dispatch(
      GetMatchListByStatus(
        value,
        sendPoolData.vid,
        sendPoolData.sdate,
        sendPoolData.edate,
        page,
        rowsPerPage
      )
    );
    
    // Current tab के according limit set करें
    const limit = valueTop === "Accumulator" ? 50 : 1000;
    dispatch(GetActiveAllContestMatchAction(1, limit, sendPoolData));

    setClickStatus(false);
    return () => {
      dispatch(ResetMatchChangeStatusAction());
    };
  }, [dispatch, page, rowsPerPage, sVid, valueTop]);

  useEffect(() => {
    if (Object.keys(statusSelector).length > 0) {
      sendPoolData.vid = sVid;
      sendPoolData.typeData = valueTop;
      
      if (dateRng.sdate && dateRng.edate) {
        sendPoolData.sdate = dateRng.sdate;
        sendPoolData.edate = dateRng.edate;
      }
      
      dispatch(
        GetMatchListByStatus(
          value,
          sendPoolData.vid,
          sendPoolData.sdate,
          sendPoolData.edate,
          page,
          rowsPerPage
        )
      );
      
      const limit = valueTop === "Accumulator" ? 50 : 1000;
      dispatch(GetActiveAllContestMatchAction(1, limit, sendPoolData));
      
      setClickStatus(false);
    }
  }, [statusSelector, page, rowsPerPage, valueTop]);

  const handleRequestSort = (_, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (_, newPage) => {
    setClickStatus(true);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setClickStatus(true);
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const applySortFilter = (array, comparator, query) => {
    const stabilizedThis = array && array.map((el, index) => [el, index]);
    if (stabilizedThis) {
      stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
    }
    if (query) {
      return filter(
        array,
        (_user) =>
          _user?.title?.toLowerCase()?.indexOf(query?.toLowerCase()) !== -1
      );
    }
    const filterData = stabilizedThis && stabilizedThis.map((el) => el[0]);
    return filterData;
  };

  const filteredUsers = applySortFilter(
    ContestList,
    getComparator(order, orderBy),
    filterName
  );

  const activateMatch = (event, is_active, match_id) => {
    setClickStatus(true);
    event.preventDefault();
    let sendData = {
      match_id: match_id,
      is_active: is_active,
    };
    dispatch(MatchChangeStatusAction(sendData));
  };

  const InactivateMatch = (event, is_active, match_id) => {
    setClickStatus(true);
    event.preventDefault();
    let sendData = {
      match_id: match_id,
      is_active: is_active,
    };
    dispatch(MatchChangeStatusAction(sendData));
  };
  
  const ViewPools = (contest_id, name) => {
    navigate(
      `/dashboard/contest-status-mangement/${contest_id}`,
      { state: { type: "m", gtype: "ckt", name: name } },
      { replace: true }
    );
  };

  const filterVendorUsers = applySortFilter(
    USERLIST,
    getComparator(order, orderBy),
    filterName
  );

  const handleMultiSelectOnChange = (event) => {
    const {
      target: { value },
    } = event;
    setSVid(value);
  };

  const onGetData = async () => {
    console.log("Search clicked for:", valueTop, "with date:", dateRng);
    
    sendPoolData.vid = sVid;
    sendPoolData.typeData = valueTop;
    
    if (dateRng.sdate && dateRng.edate) {
      sendPoolData.sdate = dateRng.sdate;
      sendPoolData.edate = dateRng.edate;
    }

    if (valueTop === "Accumulator") {
      setLoadingAccumulator(true);
    }

    const limit = valueTop === "Accumulator" ? 50 : 1000;
    
    await dispatch(
      GetMatchListByStatus(
        value,
        sendPoolData.vid,
        sendPoolData.sdate,
        sendPoolData.edate,
        page,
        rowsPerPage
      )
    );
    
    await dispatch(GetActiveAllContestMatchAction(1, limit, sendPoolData));
    
    if (valueTop === "Accumulator") {
      setLoadingAccumulator(false);
    }
    setClickStatus(false);
  };

  const onChangeDate = (e) => {
    let sdate = moment(e[0]).format("YYYY-MM-DDT00:00:00");
    let edate = moment(e[1]).format("YYYY-MM-DDT23:59:59");
    setDateRng({ sdate, edate });
  };

  // Calculate totals for Contest tab
  const calculateContestTotals = () => {
    let Totaljoineduser = 0;
    let Totalwinsum = 0;
    let Totaltotalamtjoiniii = 0;
    let Totalplatformrake = 0;

    if (poolListData && poolListData.contestData) {
      poolListData.contestData.forEach((data) => {
        Totaljoineduser += data.joineduser || 0;
        Totalwinsum += data.winsum || 0;
        Totaltotalamtjoiniii += (data.joineduser || 0) * (data.joinfee || 0);

        if ((data.joineduser || 0) > 1) {
          Totalplatformrake += (data.joineduser || 0) * (data.joinfee || 0) - (data.winsum || 0);
        }
      });
    }

    return { Totaljoineduser, Totalwinsum, Totaltotalamtjoiniii, Totalplatformrake };
  };

  const contestTotals = calculateContestTotals();

  return (
    <Page title="Upcoming Matches">
      {clickStatus || loadingSelector ? <Loader /> : null}
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Cricket Match Status"
          links={[
            { name: "Dashboard", href: "/dashboard/app" },
            { name: "Cricket Match Status" },
          ]}
        />

        <Card>
          <br />
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="access-module-select" shrink>
                  Vendors
                </InputLabel>
                <Select
                  labelId="access-module-select"
                  value={sVid}
                  onChange={handleMultiSelectOnChange}
                  input={<OutlinedInput label="Access Module" />}
                >
                  <MenuItem value="">
                    <em>--- Select ---</em>
                  </MenuItem>
                  {filterVendorUsers &&
                    filterVendorUsers?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <DateRangePicker 
                onChange={onChangeDate}
                ranges={[
                  {
                    label: 'Today',
                    value: [new Date(), new Date()]
                  },
                  {
                    label: 'Yesterday',
                    value: [new Date(new Date().setDate(new Date().getDate() - 1)), new Date(new Date().setDate(new Date().getDate() - 1))]
                  },
                  {
                    label: 'Last 7 Days',
                    value: [new Date(new Date().setDate(new Date().getDate() - 6)), new Date()]
                  },
                  {
                    label: 'Last 30 Days',
                    value: [new Date(new Date().setDate(new Date().getDate() - 29)), new Date()]
                  }
                ]}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={4}>
              <div className="reset-filter">
                <Button
                  size="large"
                  color="primary"
                  className="btn"
                  variant="contained"
                  type="submit"
                  onClick={onGetData}
                  disabled={loadingAccumulator}
                >
                  {loadingAccumulator ? "Loading..." : "Search"}
                </Button>
              </div>
            </Grid>
          </Grid>
          
          {loadingAccumulator && <LinearProgress />}
          
          <TabContext value={valueTop}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChangeTop}
                aria-label="Status management Tabs"
              >
                <Tab label="Contest" value="Contest" key="0" />
                <Tab label="Accumulator" value="Accumulator" key="1" />
              </TabList>
            </Box>
            <TabPanel value="Contest" key="0">
              <TableContainer sx={{ minWidth: 800, minHeight: 100 }}>
                <Table>
                  <UserListHead
                    headLabel={[
                      {
                        id: "joineduser",
                        label: "Total User Join",
                        alignRight: false,
                      },
                      { id: "winsum", label: "Total Win", alignRight: false },
                      {
                        id: "totalamtjoiniii",
                        label: "Total Joining Amount",
                        alignRight: false,
                      },
                      {
                        id: "platformrake",
                        label: "Platform Rake",
                        alignRight: false,
                      },
                    ]}
                  />
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {contestTotals.Totaljoineduser}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {contestTotals.Totalwinsum}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {contestTotals.Totaltotalamtjoiniii}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {contestTotals.Totalplatformrake}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </TabPanel>
            <TabPanel value="Accumulator" key="1">
              <TableContainer sx={{ minWidth: 800, minHeight: 100 }}>
                <Table>
                  <UserListHead
                    headLabel={[
                      { id: "c_no", label: "Sr no.", alignRight: false },
                      { id: "usersum", label: "No.Of User", alignRight: false },
                      {
                        id: "rshrsum",
                        label: "No.Of shares taken",
                        alignRight: false,
                      },
                      {
                        id: "wincnt",
                        label: "No.Of shares winning",
                        alignRight: false,
                      },
                      {
                        id: "rtgkamount",
                        label: "Total join amount",
                        alignRight: false,
                      },
                      { id: "winamt", label: "Total Win", alignRight: false },
                      {
                        id: "pltfeeamt",
                        label: "Platform fee",
                        alignRight: false,
                      },
                      {
                        id: "platformrake",
                        label: "Platform rake",
                        alignRight: false,
                      },
                      {
                        id: "platformcommission",
                        label: "Platform commission",
                        alignRight: false,
                      },
                    ]}
                  />
                  <TableBody>
                    {poolListData && poolListData.contestData && poolListData.contestData.length > 0 ? (
                      poolListData.contestData.map((data, index) => {
                        const platformFee = data.pltfeeamt || 0;
                        const totalJoinAmount = data.rtgkamount || 0;
                        const totalWin = data.winamt || 0;
                        const platformRake = Math.max(0, totalJoinAmount - totalWin);
                        const platformCommission = platformFee + platformRake;

                        return (
                          <TableRow key={data.id || index}>
                            <TableCell component="th" scope="row">
                              {index + 1}.
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.usersum || 0}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.rshrsum || 0}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {data.wincnt || 0}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {totalJoinAmount}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {totalWin}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {platformFee}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {platformRake}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {platformCommission}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                          <Typography variant="body2">
                            {loadingAccumulator ? "Loading accumulator data..." : "No accumulator data found for selected criteria"}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </TabPanel>
          </TabContext>
        </Card>

        <Card>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="Status management Tabs"
              >
                <Tab label="Upcoming/Live Match" value="UPCOMINGLIVE" key="0" />
                <Tab label="Result Match" value="RESULT" key="1" />
                <Tab label="Cancel Match" value="CANCEL" key="2" />
              </TabList>
            </Box>
            
            <TabPanel value="UPCOMINGLIVE" key="0">
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={[
                        { id: "c_no", label: "Sr no.", alignRight: false },
                        { id: "c_id", label: "Match ID", alignRight: false },
                        {
                          id: "c_team1vsteam2",
                          label: "Teams Title",
                          alignRight: false,
                        },
                        {
                          id: "is_playing11 ",
                          label: "Line Up",
                          alignRight: false,
                        },
                        {
                          id: "rstatus ",
                          label: "Live Status",
                          alignRight: false,
                        },
                        {
                          id: "is_cscore  ",
                          label: "Match Score",
                          alignRight: false,
                        },
                        {
                          id: "status_note  ",
                          label: "Match Status",
                          alignRight: false,
                        },
                        {
                          id: "c_date",
                          label: "Date & Time",
                          alignRight: false,
                        },
                      ]}
                      rowCount={state.totalCountContestList}
                      numSelected={selected.length}
                    />
                    <TableBody>
                      {filteredUsers ? (
                        filteredUsers.map((data, index) => {
                          return data.is_active != 2 ? (
                            <TableRow key={index}>
                              <TableCell component="th" scope="row">
                                {page * rowsPerPage + (index + 1)}.
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.match_id}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.title}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.is_playing11 == 1 ? (
                                  <Iconify
                                    icon="mingcute:check-fill"
                                    width={24}
                                    height={24}
                                    color="#00FF00"
                                  />
                                ) : (
                                  <Iconify
                                    icon="mdi:cancel-bold"
                                    width={24}
                                    height={24}
                                    color="#ea1f0f"
                                  />
                                )}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.rstatus == 2 ? "Live" : "Fixture"}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.rstatus == 2 ? (
                                  data.teama.scores_full == "" &&
                                  data.teamb.scores_full == "" ? (
                                    <Iconify
                                      icon="mdi:cancel-bold"
                                      width={24}
                                      height={24}
                                      color="#ea1f0f"
                                    />
                                  ) : (
                                    <Iconify
                                      icon="mingcute:check-fill"
                                      width={24}
                                      height={24}
                                      color="#00FF00"
                                    />
                                  )
                                ) : (
                                  "---"
                                )}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.status_note}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.date_start_ist
                                  ? new Date(data.date_start_ist)
                                      .toUTCString()
                                      .split("GMT")[0]
                                  : "-"}
                              </TableCell>
                            </TableRow>
                          ) : (
                            ""
                          );
                        })
                      ) : (
                        <Loader />
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[25, 50, 100, 150, 200]}
                component="div"
                count={state.totalCountContestList}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TabPanel>

            <TabPanel value="RESULT" key="1">
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={[
                        { id: "c_no", label: "Sr no.", alignRight: false },
                        { id: "c_id", label: "Match ID", alignRight: false },
                        {
                          id: "c_team1vsteam2",
                          label: "Teams Title",
                          alignRight: false,
                        },
                        {
                          id: "is_playing11 ",
                          label: "Line Up",
                          alignRight: false,
                        },
                        {
                          id: "is_paid ",
                          label: "Contest Paid",
                          alignRight: false,
                        },
                        {
                          id: "plyacc_ispaid ",
                          label: "PlayerAcc Paid",
                          alignRight: false,
                        },
                        {
                          id: "status_note ",
                          label: "Match Last Status",
                          alignRight: false,
                        },
                        {
                          id: "c_date",
                          label: "Date & Time",
                          alignRight: false,
                        },
                        {
                          id: "c_pool",
                          label: "Pool Contest",
                          alignRight: false,
                        },
                      ]}
                      rowCount={state.totalCountContestList}
                      numSelected={selected.length}
                    />
                    <TableBody>
                      {filteredUsers ? (
                        filteredUsers.map((data, index) => {
                          return data.is_active != 2 ? (
                            <TableRow key={index}>
                              <TableCell component="th" scope="row">
                                {page * rowsPerPage + (index + 1)}.
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.match_id}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.title}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.is_playing11 == 1 ? (
                                  <Iconify
                                    icon="mingcute:check-fill"
                                    width={24}
                                    height={24}
                                    color="#00FF00"
                                  />
                                ) : (
                                  <Iconify
                                    icon="mdi:cancel-bold"
                                    width={24}
                                    height={24}
                                    color="#ea1f0f"
                                  />
                                )}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.is_paid == 1 ? (
                                  <Iconify
                                    icon="mingcute:check-fill"
                                    width={24}
                                    height={24}
                                    color="#00FF00"
                                  />
                                ) : (
                                  <Iconify
                                    icon="mdi:cancel-bold"
                                    width={24}
                                    height={24}
                                    color="#ea1f0f"
                                  />
                                )}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.plyacc_ispaid == 1 ? (
                                  <Iconify
                                    icon="mingcute:check-fill"
                                    width={24}
                                    height={24}
                                    color="#00FF00"
                                  />
                                ) : (
                                  <Iconify
                                    icon="mdi:cancel-bold"
                                    width={24}
                                    height={24}
                                    color="#ea1f0f"
                                  />
                                )}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.status_note}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.date_start_ist
                                  ? new Date(data.date_start_ist)
                                      .toUTCString()
                                      .split("GMT")[0]
                                  : "-"}
                              </TableCell>
                              <TableCell>
                                <Button
                                  onClick={() =>
                                    ViewPools(data.match_id, data.title)
                                  }
                                >
                                  <Iconify
                                    icon="eva:eye-fill"
                                    width={24}
                                    height={24}
                                  />
                                </Button>
                              </TableCell>
                            </TableRow>
                          ) : (
                            ""
                          );
                        })
                      ) : (
                        <Loader />
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[25, 50, 100, 150, 200]}
                component="div"
                count={state.totalCountContestList}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TabPanel>

            <TabPanel value="CANCEL" key="2">
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={[
                        { id: "c_no", label: "Sr no.", alignRight: false },
                        { id: "c_id", label: "Match ID", alignRight: false },
                        {
                          id: "c_team1vsteam2",
                          label: "Teams Title",
                          alignRight: false,
                        },
                        {
                          id: "is_playing11 ",
                          label: "Line Up",
                          alignRight: false,
                        },
                        {
                          id: "joinmconts ",
                          label: "Contest Cancelled",
                          alignRight: false,
                        },
                        {
                          id: "joinsaccplys ",
                          label: "PlayerAcc Cancelled",
                          alignRight: false,
                        },
                        {
                          id: "status_note ",
                          label: "Match Last Status",
                          alignRight: false,
                        },
                        {
                          id: "c_date",
                          label: "Date & Time",
                          alignRight: false,
                        },
                      ]}
                      rowCount={state.totalCountContestList}
                      numSelected={selected.length}
                    />
                    <TableBody>
                      {filteredUsers ? (
                        filteredUsers.map((data, index) => {
                          return data.is_active != 2 ? (
                            <TableRow key={index}>
                              <TableCell component="th" scope="row">
                                {page * rowsPerPage + (index + 1)}.
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.match_id}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.title}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.is_playing11 == 1 ? (
                                  <Iconify
                                    icon="mingcute:check-fill"
                                    width={24}
                                    height={24}
                                    color="#00FF00"
                                  />
                                ) : (
                                  <Iconify
                                    icon="mdi:cancel-bold"
                                    width={24}
                                    height={24}
                                    color="#ea1f0f"
                                  />
                                )}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.joinmconts}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.joinsaccplys}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.status_note}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {data.date_start_ist
                                  ? new Date(data.date_start_ist)
                                      .toUTCString()
                                      .split("GMT")[0]
                                  : "-"}
                              </TableCell>
                            </TableRow>
                          ) : (
                            ""
                          );
                        })
                      ) : (
                        <Loader />
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[25, 50, 100, 150, 200]}
                component="div"
                count={state.totalCountContestList}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </Page>
  );
}